// extracted by mini-css-extract-plugin
export default {"Container":"SensorData_Container__s4Mwo","Loading":"SensorData_Loading__kVxhg"};